import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { SidenavService } from '../../../services/util/sidenav.service';
import { ContactUsDialogComponent } from '../../../layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-not-found-error',
    templateUrl: './not-found-error.html',
    styleUrls: ['./not-found-error.scss'],
    standalone: false
})
export class NotFoundErrorComponent implements OnInit {

  tenant: string;
  RouterSegments = RouterSegments;

  constructor(private router: Router, private sideNav: SidenavService, private authService: AuthService,
     private readonly titleService: Title,
    private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.titleService.setTitle(this.route.snapshot.data.title);
  }

  goBack(): void {
    if (window.history.length > 4) {
      window.history.go(-2);
    }
    else {
      this.router.navigate(['/'+ this.tenant]);
    }
  }
  openContactForm(): void {
    this.sideNav.openInRightSidenav(ContactUsDialogComponent);
  }

  onSupportClick(): void { 
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

}
